import { useInfiniteFetch } from '@/core/hooks/use-infinite-fetch'
import { getCountries } from '@/features/locations/providers/client'
import { CountryModel } from '@/features/locations/types/models/country.model'
import { useMemo } from 'react'

type UseCountriesProps = {
  initialPage?: number
  limit?: number
  isActive?: boolean
  search?: string
}

export function useCountries({
  initialPage = 1,
  limit = 10,
  isActive,
  search,
}: UseCountriesProps = {}) {
  const fetchParams = useMemo(
    () => (search ? { isActive, search, page: 1 } : { isActive }),
    [isActive, search],
  )

  const {
    items: countries,
    hasMore,
    isLoading,
    error,
    pagination,
    onLoadMore,
    reset,
  } = useInfiniteFetch<CountryModel[], 'countries'>(getCountries, {
    initialPage,
    limit,
    dataKey: 'countries',
    fetchParams,
  })

  return {
    countries,
    hasMore,
    isLoading,
    error,
    pagination,
    onLoadMore,
    reset,
  }
}
